import { DSSpacer } from '@zoe/ds-web'
import { ModularContentBlocks, renderModularBlocks } from '../renderModularBlocks'

type HomePageContentProps = {
  content: ModularContentBlocks[]
}

export const HomepageContent = ({ content }: HomePageContentProps) => {
  return (
    <>
      <DSSpacer direction="vertical" size={72} />
      {(content ?? []).map((record, index) => renderModularBlocks(record, index))}
    </>
  )
}
